<div class="logo-intestazione" [style]="css_logo">

</div>